import React from "react";
import { Button } from "react-bootstrap";
import { Icons } from "../Icons";
const Buttons = (props) => {
  return (
    <>
      <Button
        variant={props.className}
        onClick={props.handleClick}
        onMouseEnter={props.onMouseEnter}
        onMouseLeave={props.onMouseLeave}
        onBlur={props.onBlur}
        id={props.id}
        disabled={props.disabled}
        style={props?.style}
        data-testid={props.testId}
        title={props.title}
      >
        {props.largeButton ? (
          <>
            <Icons iconname={props.iconname} variant={props.variantname} />
            {props.name}{" "}
          </>
        ) : props.iconPosition === "left" ? (
          <>
            {props.iconname ? (
              <Icons iconname={props.iconname} variant={props.variantname} />
            ) : (
              ""
            )}
            {props.name}
          </>
        ) : props.iconPosition === "right" ? (
          <>
            {props.iconname ? (
              <Icons iconname={props.iconname} variant={props.variantname} />
            ) : (
              ""
            )}
            {props.name}
          </>
        ) : (
          <>
            {props.fundSwitchFetching ||
            props.fundSwitchFutureFetching ||
            props.lumpSumsFetching ||
            props.flexiAccessFetching ||
            props.traFundSwitchFetching ? (
              <div
                data-testid="loading-spinner"
                className="loading-spinner-loader"
              ></div>
            ) : (
              props.name
            )}
            {props.iconname ? (
              <Icons iconname={props.iconname} variant={props.variantname} />
            ) : (
              ""
            )}
          </>
        )}
      </Button>
      {/* To import buttons */}
      {/* <Buttons className="primary" name="Primary" />
      <Buttons className="secondary" name="Secondary" />
      <Buttons className="tertiary" name="Tertiary" />
      <Buttons className="outline-success" name="Sign out" /> */}
    </>
  );
};

export default Buttons;
